import { Route } from "react-router-dom";
import { APP_URLS } from "../../utils/constant";
import HolidaysScreen from "../../container/HolidaysScreen";
import CreateHolidays from "../../container/HolidaysScreen/CreateHolidays";

const HolidaysRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.HOLIDAYS.HOME}
          element={<HolidaysScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route path={APP_URLS.HOLIDAYS.CREATE} element={<CreateHolidays />} />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.HOLIDAYS.EDIT}
          element={<CreateHolidays isEdit={true} />}
        />
      )}
    </>
  );
};

export default HolidaysRoutes;
